import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { merge } from 'es-toolkit';
import {tap} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {BaseService} from '@shared/services/base.service';
import {ContactsService} from '../contacts/contacts.service';

@Injectable({
  providedIn: 'root'
})
export class ComplaintsService extends BaseService {
  public item: any = {};
  public meta: any = {};

  incidentsService: BaseService;
  incidentAttachService: BaseService;
  investigateService: BaseService;
  incidentContactsService: BaseService;

  constructor(http: HttpClient, private contactsService: ContactsService) {
    super(`${environment.baseUrl}/complaints/attributes`, http);
    this.incidentsService = new BaseService(`${environment.baseUrl}/complaints/incidents`, http);
    this.incidentAttachService = new BaseService(`${environment.baseUrl}/complaints/incidentsattach`, http);
    this.investigateService = new BaseService(`${environment.baseUrl}/investigate`, http);
    this.incidentContactsService = new BaseService(`${environment.baseUrl}/complaints/incidents/contacts`, http);
  }

  private selectChoice(selected, item) {
    Object.keys(selected).forEach(key => item['contact_' + key] = selected[key]);
  }

  loadData(searchObj): Observable<any> {
    return this.getList<any>(searchObj).pipe(tap(response => {
      if (response.results[0]) {
        merge(this.item, response.results[0]);
      } else {
        this.item = {};
      }

      merge(this.meta, response.meta);

      if (!this.meta.fields) {
        this.meta.fields = {};
      }

      this.meta.type = 'complaints/attributes';
      this.meta.urlPath = 'complaints';
      this.meta.foreign_key_field = 'site';
      this.meta.subItems = ['incidents'];

      // Incidents sub-items
      this.meta.fields.incidents = {
        // verbose_name_plural: 'Incidents',
        // verbose_name: 'Incident',
        display_fields: [
          'incident_id', 'received_datetime', 'received_by', 'incident_type',
          'incident_details', 'quantity',
          'alleged_violation', 'alleged_other',
          'is_duplicate', 'duplicate_complaint'
        ],
        foreign_key_field: 'complaints_attribute',
        type: 'complaints/incidents',
        subItems: ['contacts', 'investigate', 'attachments']
      };

      // Contacts sub-item on incidents
      this.meta.fields.incidents.contacts = {
        type: 'complaints/incidents/contacts',
        display_fields: ['relationship_type', 'contact_display_name', 'contact_contact_type'],
        foreign_key_field: 'incident',
        fields: {
          relationship_type: {
            required: true
          },
          contact_first_name: {
            get_choices: (s) => this.contactsService.meta.fields.contact_first_name.get_choices(s),
            select_choice: (selected, item) => this.selectChoice(selected, item),
            choices: null
          },
          contact_org_name: {
            get_choices: (s) => this.contactsService.meta.fields.contact_org_name.get_choices(s),
            select_choice: (selected, item) => this.selectChoice(selected, item),
            choices: null
          }
        }
      };

      // Investigation assignments via review_routing (rendered by app-routing-review)
      this.meta.fields.incidents.investigate = {
        // verbose_name_plural: 'Investigation Assignments',
        // verbose_name: 'Investigation Assignment'
      };

      // Incident-level attachments
      this.meta.fields.incidents.attachments = {
        verbose_name_plural: 'Attachments',
        verbose_name: 'Attachment',
        display_fields: ['name', 'size', 'created_date', 'created_user'],
        foreign_key_field: 'incident',
        type: 'complaints/incidentsattach'
      };
    }));
  }

  loadInvestigateData(searchObj): Observable<any> {
    return this.incidentsService.getList<any>(searchObj).pipe(tap(response => {
      merge(this.meta, response.meta);
      this.meta.display_fields = [
        'incident_id', 'received_datetime', 'received_by', 'incident_type',
        'incident_details', 'quantity', 'created_date'
      ];
      this.meta.type = 'complaints/incidents';
      this.meta.urlPath = 'complaints';
    }));
  }
}
